export default "__VITE_ASSET__BJ8n8NOq__"